import {SET_AUTHENTIFICATION, PARSE_MESSAGE, PARSE_ERROR, RESET_ERROR } from "./ActionsTypes";
import axios from 'axios';

const BASE_URL = "http://localhost:3001";

export function setAuthentification(isLoggedIn) {
    return {
        type: SET_AUTHENTIFICATION,
        payload: isLoggedIn
    }
}

export function signinUser({email, password}, history) {
    return function(dispatch) {
        axios.post(`${BASE_URL}/signin`, {
            email,
            password
        }).then( (response) => {
            localStorage.setItem("token", response.data.token);
            dispatch(setAuthentification(true));
            history.push('/ressources');
        }).catch( (error) => {
            console.log(error);
        });
    }
}

export function signoutUser() {
    return function(dispatch) {
        dispatch(setAuthentification(false));
        localStorage.removeItem('token');
    }
}

export function signupUser({email, password}, history) {
    return function(dispatch) {
        axios.post(`${BASE_URL}/signup`, {
            email,
            password
        }).then( (response) => {
            localStorage.setItem("token", response.data.token);
            dispatch(setAuthentification(true));
            history.push('/ressources');
        }).catch( (error) => {
            console.log(error);
        });
    }
}

export function getSpecialRessource() {
    return function(dispatch) {
        axios.get(`${BASE_URL}/getSpecialRessource`, {
            headers: { authorization: localStorage.getItem("token")}
        }).then( (response) => {
            dispatch({type: PARSE_MESSAGE, payload: response.data.result});
        }).catch( (error) => {
            console.log(error);
        });
    }
}

export function parseError(error) {
    return {type: PARSE_ERROR, payload: error}
}

export function resetError() {
    return { type: RESET_ERROR}
}